import { PixelCrop } from 'react-image-crop';

const MAX_OUTPUT_DIMENSION = 1920;

export async function setCanvasPreview(image: HTMLImageElement, canvas: HTMLCanvasElement, crop: PixelCrop) {
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No 2d context');
  }

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const pixelRatio = window.devicePixelRatio;

  const naturalCropW = crop.width * scaleX;
  const naturalCropH = crop.height * scaleY;
  const longest = Math.max(naturalCropW, naturalCropH) * pixelRatio;
  const cap = longest > MAX_OUTPUT_DIMENSION ? MAX_OUTPUT_DIMENSION / longest : 1;

  canvas.width = Math.floor(naturalCropW * pixelRatio * cap);
  canvas.height = Math.floor(naturalCropH * pixelRatio * cap);

  ctx.scale(pixelRatio * cap, pixelRatio * cap);
  ctx.imageSmoothingQuality = 'high';

  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;

  ctx.save();

  ctx.translate(-cropX, -cropY);
  ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight);

  ctx.restore();
}
